import hotToast from "react-hot-toast";

/*
 * The app's toasts, on react-hot-toast. Keeps the success/error/warning/info calls the
 * screens already make, and maps the old react-toastify `autoClose` option to `duration`.
 * Position is set once on the <Toaster />, so per-call positions are ignored. Passing an `id`
 * replaces the earlier toast with that id instead of stacking a duplicate.
 */
const options = ({ autoClose, id } = {}) => ({
  ...(autoClose && { duration: autoClose }),
  ...(id && { id }),
});

export const toast = {
  success: (message, opts) => hotToast.success(message, options(opts)),
  error: (message, opts) => hotToast.error(message, options(opts)),
  warning: (message, opts) => hotToast(message, { icon: "⚠️", ...options(opts) }),
  info: (message, opts) => hotToast(message, { icon: "ℹ️", ...options(opts) }),
  dismiss: hotToast.dismiss,
};

export default toast;
